<template>
  <div class="content-box">
              <ol start="1">
                <li>
                  角色信息已通过官方审验，因时间因素造成排行榜，称号，装备到期等变化,不视为信息失实;
                </li>
                <li>
                  购买后，角色小号自动转入你的账号，重新登录游戏选择对应小号即可；
                </li>
                <li>
                  交易过程仅限小号转移，不存在游戏账号交易或换绑行为,无需担心角色找回;
                </li>
                <li>
                  购买前请下载游戏确认系统是否支持进入游戏；
                </li>
                <li>购买成功后，如遇游戏停服，损失将于买方承担；</li>
                <li>交易完成后，非交易问题不支持退货退款，如不接受请勿购买!</li>
                <li>
                  请勿私下交易，如遇被骗或被找回官方有权不处理不负责该类问题
                </li>
                <li>如交易完成后遇到问题，请在24小时内联系客服处理。</li>
              </ol>
  </div>
</template>

<style scoped="scoped">
.content-box {
  padding-left: 24px;
  padding-right: 24px;
  background-color: #fff;
  min-height: 100vh;
}

.content-box h3 {
  font-size: 37px;
  font-family: PingFang SC;
  font-weight: 650;
  color: #333333;
}

.content-box img {
  height: 97px;
  object-fit: fill;
  width: 100%;
  margin-top: 20px;
}

ol{
    margin-top: 10px
}

ol li {
  list-style-type: decimal;
  list-style-position: inside;
  font-size: 30px;
  margin-top: 10px;
}
ol li:nth-of-type(4){
  color:#DA7978 ;
}
</style>